export const enUS = {
  openPhoto: 'Open photo',
  title: 'Select a Photo',
  cancel: 'Cancel',
  takePhoto: 'Take Photo',
  chooseFromLibrary: 'Choose from Library',
}
